import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import {
    getAbTestsSelector,
    getAppFeatures,
    getIsUserBuyerSelector, getUserSelectedAccountCode
} from "../../app/appSelectors";
import { ACCOUNT_TYPES, FEATURES } from "../../app/appConstants";
import parseAccountName from "../../utils/parseAccountName";
import { AB_TESTS_NAMES } from "../AbTests/abTestsConstants";

const demoLimitsSelector = (state: IRootState) => state.demoLimits;

export const getFreeOrdersLeftSelector = createSelector(demoLimitsSelector, state => state.freeOrdersLeft);

export const getOrdersLimitSelector = createSelector(demoLimitsSelector, state => state.ordersLimit);

export const getFreeOrdersLeftLoadingSelector = createSelector(demoLimitsSelector, state => state.isLoading);

export const getFreeOrdersLeftErrorSelector = createSelector(demoLimitsSelector, state => state.error);

export const getIsDemoLimitsFeatureAndAbTestAvailableSelector = createSelector([getAppFeatures, getAbTestsSelector], (features, abTests) => {
    const isFeatureEnabled = !!features[FEATURES.DEMO_LIMITS];
    const demoLimitsAbTest = abTests[AB_TESTS_NAMES.DEMO_LIMITS];
    const abTestOption = demoLimitsAbTest?.option;
    return isFeatureEnabled && !!demoLimitsAbTest && abTestOption !== 0;
});

export const getIsDemoLimitsAvailableSelector = createSelector([getIsDemoLimitsFeatureAndAbTestAvailableSelector, getIsUserBuyerSelector, getUserSelectedAccountCode, getFreeOrdersLeftErrorSelector], (isDemoLimitsFeatureAndAbTestAvailableSelector, isBuyer, userSelectedAccountCode, isLoadingError) => {
    const accountType = parseAccountName(userSelectedAccountCode)?.type;
    const isDemo = accountType === ACCOUNT_TYPES.DEMO;
    return isDemo && !isBuyer && !isLoadingError && isDemoLimitsFeatureAndAbTestAvailableSelector;
});

export const getIsDemoLimitReachedSelector = createSelector([getIsDemoLimitsAvailableSelector, getFreeOrdersLeftSelector], (isFeatureAvailable, freeOrdersLeft) => {
    return isFeatureAvailable && freeOrdersLeft !== null && freeOrdersLeft < 1;
});
